// DnD type constants
export const ItemTypes = {
    PRODUCT_ITEM: "product_item"
};

export const ItemIds = {
    UNASSIGNED: "unassigned"
};
